import React from 'react';
import Protected from 'auth/Protected';
import PageAccessDenied from 'pages/page_accessdenied/PageAccessDenied';

/**
 * ProtectedRoute agora recebe apenas:
 * - requires: permissão necessária
 * - element: componente a ser renderizado
 */
function ProtectedRoute({ requires, element }) {
  return (
    <Protected requires={requires} fallback={<PageAccessDenied />}>
      {element}
    </Protected>
  );
}

export default ProtectedRoute;
